import { TemplateRef, Directive, inject } from '@angular/core';

@Directive({
  selector: '[selectLabel]',
  standalone: false,
})
export class SelectLabel {
  readonly template = inject<TemplateRef<any>>(TemplateRef);
}
